import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './GlobalPresence.css';

const mapDots = Array.from({ length: 50 }, (_, index) => ({
  left: `${(index * 37) % 100}%`,
  top: `${(index * 53 + 11) % 100}%`,
  delay: `${(index % 7) * 0.35}s`
}));

const GlobalPresence = () => {
  const [activeRegion, setActiveRegion] = useState('global');

  const regions = [
    { id: 'global', name: 'Global', offices: 31, lawyers: '3,000+' },
    { id: 'americas', name: 'Americas', offices: 6, lawyers: '800+' },
    { id: 'emea', name: 'EMEA', offices: 18, lawyers: '1,500+' },
    { id: 'apac', name: 'Asia Pacific', offices: 7, lawyers: '700+' }
  ];

  const highlights = [
    'Leading cross-border capabilities in every major market',
    'Seamless coordination across time zones and jurisdictions',
    'Local expertise with global resources and standards',
    'Established relationships with regulators worldwide'
  ];

  return (
    <section className="global-presence" id="locations">
      <div className="global-bg">
        <div className="global-overlay"></div>
      </div>

      <div className="section-container">
        <motion.div
          className="global-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">GLOBAL REACH</span>
          <h2 className="section-title">
            Worldwide Network,
            <br />
            <span className="title-accent">Local Expertise</span>
          </h2>
        </motion.div>

        <div className="global-content">
          <motion.div
            className="regions-selector"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {regions.map((region) => (
              <button
                key={region.id}
                className={`region-btn ${activeRegion === region.id ? 'active' : ''}`}
                onClick={() => setActiveRegion(region.id)}
              >
                <div className="region-name">{region.name}</div>
                <div className="region-stats">
                  <span>{region.offices} Offices</span>
                  <span className="stat-divider">|</span>
                  <span>{region.lawyers} Lawyers</span>
                </div>
              </button>
            ))}
          </motion.div>

          <motion.div
            className="global-map"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="map-container">
              <div className="map-dots">
                {mapDots.map((dot, index) => (
                  <div
                    key={index}
                    className="map-dot"
                    style={{
                      left: dot.left,
                      top: dot.top,
                      animationDelay: dot.delay
                    }}
                  />
                ))}
              </div>
              <div className="map-lines">
                {[...Array(8)].map((_, i) => (
                  <svg key={i} className="connection-line" viewBox="0 0 100 100">
                    <path
                      d={`M ${20 + i * 10} 50 Q 50 ${20 + i * 5} ${80 - i * 10} 50`}
                      stroke="rgba(212, 175, 55, 0.3)"
                      strokeWidth="0.5"
                      fill="none"
                    />
                  </svg>
                ))}
              </div>
            </div>
          </motion.div>

          <motion.div
            className="global-highlights"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="highlights-grid">
              {highlights.map((highlight, index) => (
                <div key={highlight} className="highlight-item">
                  <div className="highlight-icon">{String(index + 1).padStart(2, '0')}</div>
                  <p>{highlight}</p>
                </div>
              ))}
            </div>
            <Link to="/locations" className="global-link">
              View all key offices
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3 8H13M13 8L8 3M13 8L8 13" stroke="currentColor" strokeWidth="1.5" />
              </svg>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default GlobalPresence;
